(function () {
  if (window.__collectionInfiniteInitialized) return;
  window.__collectionInfiniteInitialized = true;

  const selector = {
    grid: '[data-infinite-grid]',
    trigger: '#CollectionInfiniteTrigger',
    item: '[data-infinite-item]',
  };

  const state = {
    observer: null,
    loading: false,
    done: false,
  };

  const classes = {
    loading: 'is-loading',
    hidden: 'collection-infinite-trigger--hidden',
    done: 'collection-infinite-trigger--done',
    entering: 'collection-infinite-item--enter',
  };

  function init() {
    const trigger = document.querySelector(selector.trigger);
    const grid = document.querySelector(selector.grid);
    if (!trigger || !grid || !trigger.dataset.nextUrl || state.done) return;

    state.observer?.disconnect();
    state.observer = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px 240px 0px' });
    if (trigger.dataset.nextUrl) {
      state.observer.observe(trigger);
    }

    const link = trigger.querySelector('.collection-infinite-link');
    if (link) {
      link.addEventListener('click', handleManualLoad);
    }
  }

  function handleManualLoad(event) {
    event.preventDefault();
    loadMore();
  }

  function onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !state.loading) {
        loadMore();
      }
    });
  }

  function loadMore() {
    const trigger = document.querySelector(selector.trigger);
    if (!trigger || !trigger.dataset.nextUrl) {
      finalize(trigger);
      return;
    }

    const nextURL = trigger.dataset.nextUrl;
    state.loading = true;
    trigger.classList.add(classes.loading);
    updateStatus(trigger, getString(trigger, 'loading'));

    fetch(nextURL + (nextURL.includes('?') ? '&' : '?') + 'section_id=' + trigger.dataset.sectionId)
      .then((response) => response.text())
      .then((htmlString) => {
        const parsed = new DOMParser().parseFromString(htmlString, 'text/html');
        const newGrid = parsed.querySelector(selector.grid);
        const newTrigger = parsed.querySelector(selector.trigger);

        if (!newGrid) {
          finalize(trigger);
          return;
        }

        appendItems(newGrid, trigger);
        updateTrigger(trigger, newTrigger);
        reinitializeAnimations();
      })
      .catch(() => finalize(trigger))
      .finally(() => {
        state.loading = false;
        trigger.classList.remove(classes.loading);
      });
  }

  function appendItems(newGrid, trigger) {
    const grid = document.querySelector(selector.grid);
    if (!grid) return;

    const fragment = document.createDocumentFragment();
    newGrid.querySelectorAll(selector.item).forEach((item, index) => {
      const clone = item.cloneNode(true);
      clone.classList.add(classes.entering);
      clone.style.setProperty('--infinite-order', index + 1);
      fragment.appendChild(clone);
    });

    grid.appendChild(fragment);

    requestAnimationFrame(() => {
      grid.querySelectorAll('.' + classes.entering).forEach((el) => {
        el.classList.remove(classes.entering);
      });
    });
  }

  function updateTrigger(currentTrigger, newTrigger) {
    if (newTrigger && newTrigger.dataset.nextUrl) {
      currentTrigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
      currentTrigger.classList.remove(classes.done, classes.hidden);
      updateStatus(currentTrigger, getString(currentTrigger, 'loadMore'));
      init();
    } else {
      finalize(currentTrigger);
    }
  }

  function updateStatus(trigger, message) {
    const statusEl = trigger.querySelector('.collection-infinite-status');
    if (statusEl) {
      statusEl.textContent = message || '';
    }
  }

  function finalize(trigger) {
    state.done = true;
    state.observer?.disconnect();
    if (trigger) {
      trigger.classList.add(classes.done);
      updateStatus(trigger, getString(trigger, 'complete'));
      trigger.dataset.nextUrl = '';
    }
  }

  function reinitializeAnimations() {
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(document);
    }
  }

  function getString(trigger, type) {
    if (!trigger) return '';
    const dataKey = `load${type.charAt(0).toUpperCase()}${type.slice(1)}Text`;
    const attribute = trigger.dataset[dataKey];
    if (attribute) return attribute;

    const fallbackMap = {
      loading: 'general.pagination.loading',
      loadMore: 'general.pagination.load_more',
      complete: 'general.pagination.complete',
    };
    return getThemeString(fallbackMap[type] || '');
  }

  function getThemeString(path) {
    const [namespace, key] = path.split('.');
    const dictionary = window.themeStrings?.[namespace];
    if (dictionary && key && dictionary[key]) {
      return dictionary[key];
    }
    return '';
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('shopify:block:deselect', init);

  document.addEventListener('facet:updated', () => {
    state.done = false;
    init();
  });
})();
